export default class ContentWrapper {
    constructor (el, className, wrapperTag = 'div') {
        this.el = el
        this.className = className
        this.wrapperTag = wrapperTag
        this.init()
    }

    init () {
        const wrapper = document.createElement(this.wrapperTag)
        this.el.parentElement.insertBefore(wrapper, this.el)
        wrapper.appendChild(this.el)
        wrapper.classList.add(this.className)
    }
}